import { AnyAction, Dispatch } from 'redux';
import {
    setMobileSideBarVisibility,
    setLanguageOptions,
    setSelectedLanguage,
} from './headerSlice';
import { axios } from '../../services/axiosService';
import { DropdownOptions } from '../dropdown/Dropdown';
import { AppState } from '../../store/appState';
import { userService } from '../../services/userService';
import i18n from '../../i18n';

export const toggleSideBar = (value: boolean) => (dispatch: Dispatch) => {
    dispatch(setMobileSideBarVisibility({ value }));
};

export const loadLanguageOptions = () => async (dispatch: Dispatch) => {
    const languages = (await axios.get('/i18n/languages')).data;
    const languageOptions: DropdownOptions[] = languages.map((l: any) => ({
        key: l.i18nCode,
        value: l.i18nCode,
        text: `${l.nativeName} (${l.enName})`,
    }));
    dispatch(setLanguageOptions(languageOptions));
};

// forceUpdateLanguage is used to force update the language in the database
// to indicate that the language was changed by the user through the dropdown
export const setLanguage =
    (language: string, forceUpdateLanguage?: boolean) =>
    async (dispatch: Dispatch, getState: () => AppState) => {
        console.log('=== setLanguage called ===');
        console.log('language:', language);
        console.log('forceUpdateLanguage:', forceUpdateLanguage);
        
        localStorage.setItem('language', language);
        
        // For unauthenticated users, store the forceUpdateLanguage flag in localStorage
        // For authenticated users, this will be stored in the database
        if (forceUpdateLanguage !== undefined) {
            localStorage.setItem('isLanguageOverwrittenByDropdown', forceUpdateLanguage.toString());
            console.log('Set isLanguageOverwrittenByDropdown to:', forceUpdateLanguage.toString());
        }
        
        dispatch(setSelectedLanguage(language));
        const state = getState();
        if (!state.auth.isAuthenticated) return;
        await userService.updateUserInfo({ language, forceUpdateLanguage });
    };

export const changeLanguage =
    (language: string) => async (dispatch: Dispatch) => {
        console.log('=== changeLanguage called ===');
        console.log('language parameter:', language);
        console.log('current i18n.language:', i18n.language);

        // Ensure language is a string, not any other type
        const languageStr = Array.isArray(language)
            ? language[0]
            : typeof language === 'string'
                ? language
                : 'en';
        console.log('language after normalization:', languageStr);

        i18n.changeLanguage(languageStr);
        dispatch(setLanguage(languageStr) as unknown as AnyAction);
    };
